import { AlertTriangle } from "lucide-react";
import { cn } from "./cn";

interface MaintenanceBannerProps {
  /** Date the site is expected to be back up. */
  expectedBackDate?: string;
  className?: string;
}

export function MaintenanceBanner({
  expectedBackDate = "1 September 2026",
  className,
}: MaintenanceBannerProps) {
  return (
    <div
      role="alert"
      className={cn(
        "absolute inset-x-0 top-0 z-20 flex items-start justify-center gap-2.5 border-b border-amber-500/30 bg-amber-500/15 px-4 py-3 text-center backdrop-blur-sm",
        className
      )}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0 text-amber-400" />
      <p className="text-xs font-medium leading-relaxed text-amber-200 sm:text-sm">
        Due to maintenance activity, the site is temporarily down and will be back up
        around {expectedBackDate}.
      </p>
    </div>
  );
}
